<template>
    <p class="well">
        <el-switch
            :value="enabled"
            class="fright"
            @change="(state) => this.$emit('update:enabled', state)"
            active-color="#13ce66">
        </el-switch>
        <span class="grey fright mt-1 mr-1 fs-3">
            {{ enableText }}
        </span>
        <span class="semibold fs-3">{{ description }}</span>
    </p>
</template>

<script>
export default {
    props : {
        enabled : {
            required: true,
            type: Boolean
        },
        description : {
            required: true,
            type: String
        },
        enableLabel : {
            required: true,
            type: String
        },
        disableLabel : {
            required: true,
            type: String
        }
    },
    computed: {
        enableText() {
            if (this.enabled) {
                return this.enableLabel
            }
            return this.disableLabel
        }
    }
}
</script>